<div class="modal-container">

    <div class="modal-header">
        <h3 class="modal-title"> {{ data.title }} </h3>

        <button class="btn" (click)="closeModal()">
            <i class="fa fa-times text-danger"></i>
        </button>
    </div>

    <div class="modal-body">
        <label> {{ data.text }} </label>
        <div class="row">
            <div class="col">
                <button type="button" class="btn btn-warning mr-3" (click)="selectStatus('Pendency')">Pendência</button>
                <button type="button" class="btn btn-primary mr-3" (click)="selectStatus('StandBy')">A Creditar</button>
                <button type="button" class="btn btn-success mr-3"
                    (click)="selectStatus('Succeeded')">Creditado</button>
            </div>
        </div>

    </div>

    <!-- Rodapé do Modal -->
    <div class="modal-footer">

        <div class="row">

            <div class="col-sm-8">
                <h1 *ngIf="statusSelected=='Pendency'">Pendência</h1>
                <h1 *ngIf="statusSelected=='StandBy'">A Creditar</h1>
                <h1 *ngIf="statusSelected=='Succeeded'">Creditado</h1>
            </div>

            <div class="col-sm-3">
                <button *ngIf="statusSelected!=null" [mat-dialog-close]="true" class="btn btn-outline-success"
                    (click)="confirmStatus()">
                    Salvar
                </button>
            </div>
        </div>



    </div>
</div>